import React from 'react';
import MapContainer from './MapContainer';
import LocationMap from './LocationMap';
import '../App.css';

export default class SignupForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {}
  }

  fetchArea(area, areaType, city, state, lat, lon, type, parentArea, parentAreaType) {
    // We have all of the address information, we just need the Area object now.
    console.log('  Fetch area got fired!');
    let url = window.location.protocol + '//' + window.location.host;
    let that = this;
    let queryParams = ['area=' + area, 'city=' +  city, 'state=' +  state, 'include_stats=true'];
    console.log('Query params are: ' + JSON.stringify(queryParams));
    fetch(`/api/v1/areas?${queryParams.join('&')}`, function(err, data) {
      if (data) {
        console.log('Got matching area information from lat/lon: ' + JSON.stringify(data));
        let response = JSON.parse(data.body);
        if (response.areas && response.areas.length === 1) {
          that.setState({area: response.areas[0], lat: lat, lon: lon, city: response.areas[0].city});
        } else {
          // Area does not exist yet. We will create it when we create this user.
          console.log('Area does not exist yet. We will create it with this user...');
          let areaData = {
            area_type: areaType,
            state: state,
            city: city,
            name: area,
            parent_area: parentArea,
            parent_area_type: parentAreaType
          };
          that.setState({newArea: areaData, lat: lat, lon: lon});
        }
        that.setState({cityName: city, stateName: state});
      } else {
       // Must be an error..
       console.log('Error fetching areas from lat/lng: ' + err);
      }
    });
  }

  refresh(e) {
    if (e) e.preventDefault();
    window.location = '/';
  }

  submitCreateAccount(event) {
    event.preventDefault();
    console.log('  Creating user!');
    // Post to the users API endpoint to create a new user validation
    //    req and associate the user with this area.
    // All the data we need should be in the state.
    console.log('this.state.password: ' + this.state.password);
    console.log('this.state.password_confirm: ' + this.state.passwordConfirm);
    if (this.state.password !== this.state.passwordConfirm) {
      this.setState({error: 'As senhas não coincidem'});
      return;
    }
    try {
      let that = this;
      let url = window.location.protocol + '//' + window.location.host;
      let formData = new FormData();
      formData.append('username', this.state.username);
      formData.append('first_name', this.state.firstName);
      formData.append('last_name', this.state.lastName);
      formData.append('email', this.state.emailAddress);
      formData.append('org_code', this.state.orgCode);
      formData.append('password', this.state.password);
      formData.append('password_confirm', this.state.passwordConfirm);
      formData.append('invite_code', this.state.inviteCode);
      formData.append('lat', this.state.lat);
      formData.append('lon', this.state.lon);
      if (this.state.area) {
        console.log('Area ID is: ' + this.state.area._id['$oid']);
        formData.append('area_id', this.state.area._id['$oid']);
      } else if (this.state.newArea) {
        formData.append('new_area', this.state.newArea);
      }
      fetch(`/api/v1/users`, {
        method: 'POST',
        body: formData,
      }, function(err, data) {
        if (err) {
          that.setState({error: err});
          console.log('Error creating account req: ' + err);
        } else if (data) {
          // We got data. Tell them to check their email which should
          // contain a link with a code.
          let jsonData = JSON.parse(data.body);
          if (data.statusCode === 404) {
            that.setState({error: 'O código de convidado é inválido'});
            return;
          }
          if (jsonData['ValidationError'] || (data.statusCode !== 200 && data.statusCode !== 204)) {
            if (jsonData['validationError']) {
              that.setState({error: jsonData['validationError']});
            } else if (jsonData['error']) {
              that.setState({error: jsonData['error']});
            } else {
              that.setState({error: data.body});
              // alert(data.body);
            }
          } else {
            that.setState({successMsg: 'Parabéns! Bem vindo ao UGov. Comece a melhorar o nosso país.'});
          }
        } else {
          console.log('Empty payload from account creation req!');
        }
      });
    } catch(e) {
      console.log('Error creating the user account req!; ' + e);
    }
  }

  fetchLocation(e) {
    if (e) e.preventDefault();
    let url = 'https://maps.googleapis.com/maps/api/geocode/json?latlng';
    // let key = 'AIzaSyCsEuLdHnu5Iyo1xtAe0xg-VGlZ0_xWyhs';
    let key = 'AIzaSyDeDym7u3Hnf-WRB7Ci69jVG8hG20Cb0i4';
    let that = this;
    let lat = this._locationMap.state.pin.lat;
    let lon = this._locationMap.state.pin.lng;
    try {
      // http://maps.googleapis.com/maps/api/geocode/json?latlng=-23.5639802135593,-46.6645690305085
      console.log('   Trying req to url: ' + url);
      fetch(`${url}=${lat},${lon}&key=${key}`, function(err, data) {
        if (err) {
          console.log(`Error(1) mapping lat/lng ${lat}/${lon} to area!  ${err}`);
        } else {
          let jsonData = JSON.parse(data.body);
          console.log(' Got google data...' + data.body);
          let area = undefined;
          let areaType = undefined;
          let parentArea = undefined;
          let parentAreaType = undefined;
          let city = undefined;
          let state = undefined;
          // sublocality_level_2 - area
          // sublocality_level_1 - area
          //  Need to preserve the hierarchy here. level 2 is more specific.
          for (let loc in jsonData.results) {
            let locObj = jsonData.results[loc];
            for (let component in locObj.address_components) {
              let mapComponent = locObj.address_components[component];
              if (mapComponent.types && mapComponent.types.indexOf('sublocality_level_2') !== -1) {
                area = mapComponent.long_name;
                areaType = 'sublocality_level_2';
              } else if (mapComponent.types && mapComponent.types.indexOf('sublocality_level_1') !== -1) {
                if (!area || (area && areaType === 'administrative_area_level_2')) {
                  area = mapComponent.long_name;
                  areaType = 'sublocality_level_1';
                } else if (area && areaType === 'sublocality_level_2') {
                  parentArea = mapComponent.long_name;
                  that.state.parentArea = parentArea;
                  parentAreaType = 'sublocality_level_1';
                }
              } else if (mapComponent.types && mapComponent.types.indexOf('administrative_area_level_2') !== -1) {
                // This is a city
                if (!area) {
                  area = mapComponent.long_name;
                  areaType = 'administrative_area_level_2';
                }
                city = mapComponent.long_name;
              } else if (mapComponent.types && mapComponent.types.indexOf('administrative_area_level_1') !== -1) {
                state = mapComponent.long_name;
              }
            }
          }
          console.log(' Do we have a city? ' + city);
          if (city) {
            that.fetchArea(area, areaType, city, state, lat, lon, areaType, parentArea, parentAreaType);
          }
        }
      });
    } catch(e) {
      console.log(`Error(2) mapping lat/lng ${lat}/${lon} to area! ${e}`);
    }
  }

  render() {
    const modalStyle = {'marginTop': '14px'};
    let addressModal = '';
    let fullAreaString = '';
    if (this.state.successMsg) {
      return (
        <div className='greyOverlay'>
          <div className='basicModal'>
            <div className='thankyou'>Sucesso!</div>
            <br /><p />
            {this.state.successMsg}
            <br /><p />
            <button className='verifyButton' onClick={(e) => this.refresh(e)} style={{width: '398px'}}>Login</button>
          </div>
        </div>
      );
    } else if (this.state.area || this.state.newArea) {
      // We have already located the area for this address and lat/lon
      // Now inform the user and associate it with their new user information.
      let areaMessage = this.state.area ? 'Excelente, seu bairro existe "' + this.state.area.name + '" exists!'
                                        : 'Parabéns! Você será o fundador da ' + this.state.newArea.name;
      let areaDisplayName = '';
      let userCount = 0;
      if (this.state && this.state.area && this.state.area.user_count) {
        userCount = this.state.area.user_count;
      }
      if (this.state && this.state.area && this.state.area.name) {
        areaDisplayName = this.state.area.name;
      } else {
        areaDisplayName = this.state.newArea.name;
      }
      let createdString = '';
      if (this.state && this.state.area && this.state.area.created_at) {
        createdString = 'Created ' + new Date(this.state.area.created_at).toString().split(' ').splice(0, 4).join(' ');
      }
      fullAreaString = areaDisplayName + ', ' + this.state.cityName + ', ' + this.state.stateName + ', Brazil';
      return (
        <div className='greyOverlay'>
          <div className='signupFoundArea'>
            <MapContainer lat={this.state.lat} lon={this.state.lon} area={{'area_full': fullAreaString}} />
            <div className='rightFloatText'>
              <b>{areaDisplayName}</b>
              <br />
              {userCount} users
              <br />
              {createdString}
            </div>
          </div>
          {this.state.error ? <div className='bannerMessageRed'>{this.state.error}</div> : ''}
          <div className='basicModal' style={modalStyle}>
            {areaMessage}
            <br /><p />
            <input className='shortInput' placeholder='Primeiro Nome' type='text' onChange={(e) => this.setState({firstName: e.target.value})}
                   value={this.state.firstName || ''} /> &nbsp;&nbsp;
            <input className='mediumInput' placeholder='Sobrenome' type='text' onChange={(e) => this.setState({lastName: e.target.value})}
                   value={this.state.lastName || ''} />
            <br />
            <input className='emailInput' placeholder='Username' type='text' onChange={(e) => this.setState({username: e.target.value})}
                   value={this.state.username || ''} />
            <br />
            <input className='shortInput' placeholder='Senha' type='password' onChange={(e) => this.setState({password: e.target.value})}
                   value={this.state.password || ''} />
            <input className='shortInput' placeholder='Confirme' type='password' onChange={(e) => this.setState({passwordConfirm: e.target.value})}
                   value={this.state.passwordConfirm || ''} />
            <br />
            <input className='emailInput' placeholder='Endereço de e-mail' type='text' onChange={(e) => this.setState({emailAddress: e.target.value})}
                   value={this.state.emailAddress || ''} />
            <br />
            <input className='emailInput' placeholder='Código de organização' type='text' onChange={(e) => this.setState({orgCode: e.target.value})}
                   value={this.state.orgCode || ''} />
            <br />
            &nbsp;&nbsp;&nbsp;<button onClick={(e) => this.submitCreateAccount(e)} className='verifyButton'>Criar Conta</button>
          </div>
        </div>
      );
    }
    // This.props.user will be empty... 
    let loc = undefined;
    if (this._locationMap) {
      if (this._locationMap.coords) {
        loc = this._locationMap.coords;
      }
    }
    if (!loc) {
      // This should never happen?
      loc = this.state.location;
    }
    return (
      <div className='signupForm'>
        <LocationMap user={this.props.user} signupComponent={this} origin='signup' loc={loc} ref={(ref) => this._locationMap = ref} />
        <div className='rightAlignDiv'>
          <button className='verifyButton' type='button' onClick={(e) => this.fetchLocation(e)}>
            <center>Verificar Locacao</center>
          </button>
        </div>
        { addressModal }
      </div>
    );
  }
}
